export default {
  //默认数据
  data() {
    return {
      //弹窗信息
      dialogContent: {},
      //默认新增页面
      Add: 'Add',
      //默认编辑页面,同新增页面,个性化页面覆盖参数
      Edit: 'Add',
      //编辑的条目数据
      EditRow: {},
      //加载数据查询条件
      search: { },
      deleteMethod: 'post',
    }
  },
  methods: {
    //新增或编辑
    add(row){
      //根据传递的参数判断是新增和编辑
      this.EditRow = typeof(row) == 'object' ? row || {} : {};
      if(!row[this.id]){
        //日常弹窗公共写法
        this.dialogContent = {
          title: this.addTitle || this.$t('common.Add'),
          width: this.addWidth || '900px',
          componentName: this.Add
        };
      }else{
        //日常弹窗公共写法
        this.dialogContent = {
          title: this.editTitle || this.$t('common.Edit'),
          width: this.editWidth || '900px',
          componentName: this.Edit
        };
      }
      //防止页面无弹窗而调用此方法报错
      this.$refs.commonDialog && this.$refs.commonDialog.show();
    },
    //删除操作
    deleteRow(row){
      //判断删除api是否存在
      if(this.deleteApi){
        //用户提示选择，删除为敏感操作
        this.$confirm(this.DeleteText || this.$t('common.DeleteText'), this.Tips || this.$t('common.Tips') ,{
          type: 'warning',
          cancelButtonText: this.$t('common.Cancel'),
          confirmButtonText: this.$t('common.Done')
        }).then(()=>{//用户选择删除
          //组合删除接口参数
          var deleteParam = {};
          deleteParam[this.id] = row[this.id];
          //删除api修改
          this.deleteApi = this.deleteApiChange && this.deleteApiChange(row) || this.deleteApi;
          //参数重置
          deleteParam = this.resetDeleteParams && this.resetDeleteParams(row) || deleteParam;
          //调用接口
          this.$ajax[this.deleteMethod](this.deleteApi, deleteParam).then(response=>{
            if(response.code == this.$config.ResultCode.SUCCESS_CODE || !response.error){
              //删除成功提示
              this.$message({
                type: 'success',
                message: this.$t('common.DeleteSuccess')
              });
              this.loadData();
            }
          }).catch(()=>{  })
        }).catch(()=>{ });
      }
    } 
  }
}